import React, { Component, ErrorInfo, ReactNode } from 'react';
import { Button } from 'antd';
import { captureSanitizedException } from '../../lib/posthog';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    console.error('ErrorBoundary caught:', error, errorInfo);
    captureSanitizedException('react_render', error, {
      componentStack: errorInfo.componentStack ?? undefined,
      handled: false,
    });
  }

  render(): ReactNode {
    if (this.state.hasError) {
      return (
        <div
          style={{
            padding: '2rem',
            maxWidth: 600,
            margin: '2rem auto',
            background: 'rgba(255,255,255,0.95)',
            borderRadius: 14,
            boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
          }}
        >
          <h2 style={{ marginBottom: '1rem' }}>Something went wrong</h2>
          <p style={{ marginBottom: '1rem', color: '#666' }}>
            {this.state.error?.message ?? 'An unexpected error occurred.'}
          </p>
          <Button type="primary" onClick={() => (window.location.href = '/clients')}>
            Back to Clients
          </Button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
